import gql from 'graphql-tag';
import { mutation, query } from 'services/graphql';

export const backgroundTemplatesQuery = gql`
  query signInCodes($input: BackgroundsInput) {
    backgrounds(input: $input) {
      nodes {
        id
        url
        description
        title
      }
      meta {
        totalCount
        count
        totalPages
        offset {
          page
          perPage
        }
      }
    }
  }
`;

const deleteBackgroundTemplate = gql`
  mutation deleteBackgroundTemplate($id: ID!) {
    deleteBackgroundTemplate(id: $id) {
      data {
        id
      }
      error
    }
  }
`;

export const deleteBackgroundTemplateMutation = mutation(
  deleteBackgroundTemplate,
);

const createBackgroundTemplate = gql`
  mutation createBackgroundTemplate($input: CreateBackgroundTemplateInput!) {
    createBackgroundTemplate(input: $input) {
      data {
        id
        url
        title
        description
      }
      error
    }
  }
`;

export const createBackgroundTemplateMutation = mutation(
  createBackgroundTemplate,
);

export default query(backgroundTemplatesQuery);
